import { createContext } from "react";

const ThemeContext = createContext({
    selectedTheme: "",
    setSelectedTheme: () => { },
    setBrandConfig: () => [],
    brandConfig: [],
    connection: null,
    setConnection: () => { },
    connectionId: null,
    setConnectionId: null
});
export default ThemeContext;